import * as React from "react";
import { createContext, useState } from "react";


export const GlobalContext = createContext(null);

export const publicSites = {
  HOME: {
    path: "/",
    name: "Home"
  },
  RESEARCH_AREA: {
    path: "/reaserch_area",
    name: "Research Area"
  },
  DR_XU: {
    path: "/dr_xu",
    name: "Dr. Xu"
  },
  PEOPLE: {
    path: "/people",
    name: "People"
  },
  PUBLICATIONS: {
    path: "/publications",
    name: "Publications"
  },
  EQUIPMENT: {
    path: "/equipment",
    name: "Equipment"
  },
  RESOURCES: {
    path: "/resources",
    name: "Resources"
  }
};

export function GlobalWrapper({ children }) {

  const [currentPath, setCurrentPath] = useState();

  const globals = {
    currentPath,
    setCurrentPath,
  };

  return (
    <GlobalContext.Provider value={globals}>{children}</GlobalContext.Provider>
  );
}
